<div class="h-1 w-full" *ngIf="!loaded">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
<div class="flex flex-col w-full preview-property-summary primary-font overflow-y-auto overflow-x-hidden zuper-scrollbar"
    *ngIf="loaded">
    <div class="relative w-full p-6 pt-7 pb-4 bg-accent-100 flex-shrink-0 dark:bg-accent-700 z-0 border-b">
        <img class="absolute inset-0 object-cover w-full h-full image-filter-blur"
            *ngIf="propertyDetails.property_image" src="{{propertyDetails.property_image}}" alt="">
        <div class="flex items-center justify-end w-full max-w-3xl mx-auto">
            <button mat-icon-button matTooltip="{{'close.text' | translate}}"
                matTooltipPosition="above"
                class="mat-focus-indicator mat-tooltip-trigger mat-icon-button mat-button-base" tabindex="0"
                (click)="closeDrawer()">
                <mat-icon role="img" class="mat-icon notranslate mat-icon-no-color" aria-hidden="true"
                    data-mat-icon-type="svg" data-mat-icon-name="x" data-mat-icon-namespace="heroicons_outline">
                    <em class="ti ti-x"></em>
                </mat-icon>
            </button>
        </div>
        <div class="relative flex w-full mt-4">
            <div
                class="ml-auto cursor-default inline-flex px-2 py-0.5 rounded text-base bg-gray-100 text-gray-600 border">
                <span class="mt-1">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-circle"
                        [ngClass]="{ 'icon-status-active': propertyDetails.is_active, 'icon-status-inactive': !propertyDetails.is_active }"
                        width="11" height="11" viewBox="0 0 24 24" stroke-width="0" stroke="currentColor" fill="none"
                        stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <circle cx="12" cy="12" r="9"></circle>
                    </svg>
                </span>
                <span class="text-md font-medium px-1 truncate">
                    {{(propertyDetails.is_active ? 'active.text' : 'text.inactive')
                    | translate}}
                </span>
            </div>
        </div>
    </div>
    <div class="-mt-12 flow-root px-4 sm:-mt-8 sm:flex sm:items-end sm:px-6 pb-2 z-10">
        <div class="-m-1 flex">
            <div class="inline-flex overflow-hidden rounded-lg border-4 border-white shadow-md flex-shrink-0">
                <img *ngIf="propertyDetails.property_image"
                    class="h-30 w-30 flex-shrink-0 sm:h-30 sm:w-30 lg:h-30 lg:w-30"
                    src="{{propertyDetails.property_image}}" alt="">
                <img *ngIf="!propertyDetails.property_image"
                    class="h-30 w-30 flex-shrink-0 sm:h-30 sm:w-30 lg:h-30 lg:w-30" src="assets/images/png/property.png"
                    alt="">
            </div>
        </div>
        <div class="my-8 mx-4 sm:ml-6 sm:flex-1 w-2/4">
            <div class="flex items-center">
                <h3 class="text-xl font-bold text-gray-900 sm:text-2xl truncate"
                    matTooltip="{{propertyDetails.property_name}}">{{propertyDetails.property_name}}</h3>
            </div>
        </div>
        <div class="my-6 ml-auto">
            <a target="_blank" class="hidden" #viewPropertyDetails href="{{getRedirectLink()}}"></a>
            <button mat-icon-button matTooltip="{{'text.view_details.new_tab' | translate}}"
                matTooltipPosition="above" (click)="viewPropertyDetails.click($event)">
                <mat-icon class="icon-size-6">open_in_new</mat-icon>
            </button>
        </div>
    </div>
    <div class="flex flex-col w-full z-10">
        <div class="flex flex-col py-5 px-6 w-full border-b">
            <div class="py-1.5 flex" *ngIf="propertyDetails.property_organization">
                <span class="text-base font-medium flex-item-wrap-leftContent">
                    {{'text.organization' | translate}}
                </span>
                <span class="text-base font-medium mr-2">:</span>
                <span class="text-base text-gray-500 flex-item-wrap cursor-default"
                    *ngIf="propertyDetails.property_organization.is_deleted || !hasAccessToOrganization">
                    {{propertyDetails.property_organization.organization_name}}
                </span>
                <a class="text-base text-gray-500 flex-item-wrap hover:underline hover:text-primary cursor-pointer text-base"
                    target="_blank"
                    [routerLink]="utilityService.getLink('ORGANIZATION', propertyDetails.property_organization.organization_uid)"
                    *ngIf="!propertyDetails.property_organization.is_deleted && hasAccessToOrganization">
                    {{propertyDetails.property_organization.organization_name}}
                </a>
            </div>
            <div class="py-1.5 flex">
                <span class="text-base font-medium flex-item-wrap-leftContent">
                    {{'text.no_of_jobs' | translate}}
                </span>
                <span class="text-base font-medium mr-2">:</span>
                <span class="text-base text-gray-500 flex-item-wrap">
                    {{propertyDetails.no_of_jobs}}
                </span>
            </div>
            <div class="py-1.5 flex" *ngIf="propertyDetails.property_address">
                <div class="flex flex-col w-full cursor-default">
                    <div class="flex">
                        <span class="text-base font-medium">
                            {{'text.property_location' | translate}}</span>
                    </div>
                    <div class="flex mt-1.5">
                        <span
                            class="text-base text-gray-500">{{getFormattedAddress(propertyDetails.property_address)}}</span>
                    </div>
                </div>
                <div class="flex -mt-3"
                    *ngIf="propertyDetails.property_address.geo_cordinates && propertyDetails.property_address.geo_cordinates.length > 1">
                    <a class="flex items-center justify-center rounded-full h-10 w-10 p-2 hover:bg-gray-200 text-primary-500 cursor-pointer"
                        target="_blank" [matTooltip]="('text.view_on_map' | translate)"
                        href="{{utilityService.getMapsCoordinatesUrl(propertyDetails.property_address.geo_cordinates[0], propertyDetails.property_address.geo_cordinates[1])}}">
                        <em class="ti ti-location icon-size-4.5 font-semibold"></em>
                    </a>
                </div>
            </div>
        </div>
        <mat-accordion *ngIf="propertyDetails.property_customers?.length">
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title class="text-secondary font-bold text-base primary-font">
                        {{'text.customers_associated' | translate}}
                        ({{propertyDetails.property_customers?.length}})
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="primary-font">
                    <customers-list
                        [options]="getCustomerListOptions(propertyDetails.property_customers)"></customers-list>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <mat-accordion class="border-b" *ngFor="let key of object.keys(customFieldGroups)">
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title class="text-secondary font-bold text-base primary-font">
                        {{customFieldGroups[key].isDefaultGroup ? ('text.other_details' |
                        translate) :
                        customFieldGroups[key].headerName}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="pt-4 px-10 primary-font">
                    <custom-fields [options]="getcustomFieldOptions(customFieldGroups[key].custom_fields)"></custom-fields>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</div>